import React from "react";

import { Route, Routes, useLocation, useNavigate } from "react-router-dom";

import useDecodedParams from "Hooks/useDecodedParams";

import * as Steps from "./components/steps";
import Setup from "./containers/ProjectSetup";

const SetupRoutes = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { organizationId: organizationNameId } = useDecodedParams();

  const goToStep = (step, organization) => {
    let path = `/create-project/${step}`;
    if (organization?.name) {
      path = `/${organization.name}${path}`;
    } else {
      path = `/${organizationNameId}${path}`;
    }
    navigate(path, { state: location?.state });
  };

  return (
    <Setup goToStep={goToStep}>
      <Routes>
        <Route
          path="template"
          element={
            <Steps.Template
              goToStep={goToStep}
              organizationNameId={organizationNameId}
            />
          }
        />
        <Route
          path="info"
          element={
            <Steps.Info
              goToStep={goToStep}
              organizationNameId={organizationNameId}
            />
          }
        />
        <Route
          path="building"
          element={
            <Steps.Building
              goToStep={goToStep}
              organizationId={organizationNameId}
            />
          }
        />

        <Route
          path="type"
          element={
            <Steps.Type
              organizationId={organizationNameId}
              goToStep={goToStep}
            />
          }
        />
        <Route
          path=""
          element={
            <Steps.Type
              organizationId={organizationNameId}
              goToStep={goToStep}
            />
          }
        />
      </Routes>
    </Setup>
  );
};

export default SetupRoutes;
